import { css as e } from "@microsoft/fast-element";
import { normalize as r } from "../common/normalize.js";
import { display as t } from "@matrix42/fast-foundation";
import { typography as l } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
const p = e`
  ${r}
  ${t("flex")}
  .control {
    /* Base */
    width: 100%;
    padding-bottom: ${o.spacing[3]};
    user-select: none;
    /* Layout */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* Style */
    border-right: ${o.borderWidth.xs} solid
      ${o.color.neutral[50]};
    /* Typography */
    ${l("p", "regular")}
  }

  :host {
    /* Base */
    width: calc(14.5 * ${o.spacing[4]});
    /* Style */
    background-color: ${o.color.neutral[30]};
  }

  .nav-items {
    /* Layout */
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
  }
`;
export {
  p as sidebarStyles
};
